import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class JwtService {
    private decodePayload(token: string): Record<string, unknown> {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(atob(base64));
    }

    isTokenExpired(token: string | null | undefined): boolean {
        if (!token) {
            return true;
        }
        try {
            const payload = this.decodePayload(token);
            const exp = payload['exp'] as number | undefined;
            if (exp === undefined) {
                return false;
            }
            return Date.now() >= exp * 1000;
        } catch {
            return true;
        }
    }

    getTokenExpirationDate(token: string): Date {
        const payload = this.decodePayload(token);
        return new Date((payload['exp'] as number) * 1000);
    }
}
